import React from 'react'
import {Table, Tag} from "antd";
import PurchaseActions from "./PurchaseActions";


const PurchaseDataTable = ({tableData, pagination = false}) => {
    const columns = [
        {
            title: 'Satın Alma No',
            dataIndex: 'purchaseNumber',
            key: 'purchaseNumber'
        },
        {
            title: 'Satın Alma Durumu',
            dataIndex: 'completedPurchase',
            key: 'completedPurchase',
            render: (t, r) => r.completedPurchase ? <Tag color={'green'}>TAMAMLANDI</Tag> :
                <Tag color={'cyan'}>BEKLİYOR</Tag>
        },
        {
            title: 'Depo Giriş Durumu',
            dataIndex: 'warehouseStatus',
            key: 'warehouseStatus',
            render: (t,r) => r.warehouseStatus ? <Tag color={'green'}>TAMAMLANDI</Tag> :
            <Tag color={'red'}>TAMAMLANMADI</Tag>,
            filters: [{text: 'TAMAMLANDI', value: true}, {text: 'TAMAMLANMADI', value: false}],
            onFilter: (value, record) => record.warehouseStatus === value
        },
        {
            title: 'Kime',
            dataIndex: 'whom',
            key: 'whom'
        },
        {
            title: 'Oluşturan',
            dataIndex: 'createdBy',
            key: 'createdBy'
        },
        {
            title: 'Oluşturma Tarihi',
            dataIndex: 'createdDate',
            key: 'createdDate'
        },
        {
            title: 'İşlemler',
            render: (t, r) => <PurchaseActions record={r}/>
        }
    ]

    return (
        <React.Fragment>
            <Table scroll={{x: 'max-content'}} columns={columns} dataSource={tableData} pagination={pagination}/>
        </React.Fragment>
    )
}
export default PurchaseDataTable